<!-- 轮播图 -->
<template>
	<div class="banner1">
		<div class="swiper-img1">
			<van-swipe :autoplay="3000" indicator-color="white" class="swipe1">
					<van-swipe-item v-for="(item,index) in swiperImg" :key="index" @click="clickSwiperImg(item)" class="swipe2">
					  <img :src="item.banner" alt="">
					  <p class="line-clamp-2" style="color:#000;padding:3px 5px;background:rgba(255,255,255,.6);border-radius:15px;width:90%;text-align:center;position:absolute;bottom:25px;left:50%;transform:translate(-50%,0);">{{item.name}}</p>
					</van-swipe-item>
			</van-swipe>
		</div>
	</div>
</template>
<script>
	import {ModulesRecommend} from "../config/interface.js"
	export default{
		props:{
			type:Number,          //1:专栏模块; 2:会议模块; 3:前沿资讯模块;4:病例模块;5:器械模块
		},
		data(){
			return{
				swiperImg:[],    //轮播图列表
			}
		},
		mounted(){
			this.getSwiperImg();
		},
		methods:{
			//轮播图
			getSwiperImg(){
				const url=ModulesRecommend;
				const method='POST';
				let params={
					module_id:this.type   //1:专栏模块; 2:会议模块; 3:前沿资讯模块;4:病例模块;5:器械模块; 6:首页;7:文章推荐
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.swiperImg=data;
					}
				})
			},
			//点击轮播图
			clickSwiperImg(item){
				//0:专栏;1:文章;2:会议
				switch(item.resource_type){
					case 0:
					if(item.is_case){
						this.$router.push({
								path:'/column/hospital',
								query:{
									id:item.id,
									channel_id:item.hospital_channel_url,
									share_img:item.share_img
								}
						});
					}else{
						this.$router.push({
								path:'/column/details',
								query:{
									id:item.id
								}
						});
					}
					break;
					// this.$router.push({
					// 	path:'/column/details',
					// 	query:{
					// 		id:item.resource_id
					// 	}
					// })
					// break;
					case 1:
					if(item.bind_url){
						window.location.href=item.bind_url;
					}else{
						this.$router.push({
							path:'/exclusiveView/details',
							query:{
								article_id:item.resource_id
							}
						})
					}
					break;	
					case 2:
					this.$router.push({
						path:'/meeting/details',
						query:{
							meeting_id:item.resource_id
						}
					})
					break;				
				}
			}

		}
	}
</script>
<style lang="scss">
.banner1{
	.swiper-img1{
		margin:0 auto;
		padding:0px 12px;
		/*width:350px;*/
		box-sizing:border-box;
		.swipe2{
			img{
				width:100%;
				height:200px;
				border-radius:5px;
			}
		}
	}
}	
</style>


// WEBPACK FOOTER //
// src/components/Banner.vue